import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-info-laboratorio',
  standalone: true,
    imports: [
        NgForOf,
        NgOptimizedImage
    ],
  templateUrl: './info-laboratorio.component.html',
  styleUrl: './info-laboratorio.component.css'
})
export class InfoLaboratorioComponent {

  services = [
    {
      "name": "Hematología "
    },{
      "name": "Microbiología "
    },{
      "name": "Marcadores Tumorales"
    },{
      "name": "Química Clínica "
    },{
      "name": "Coagulación y Hemostasia "
    },{
      "name": "Hormonas"
    },{
      "name": "Serología "
    },{
      "name": "Uroanálisis "
    },{
      "name": "Biología Molecular "
    },{
      "name": "Coprología "
    },{
      "name": "Toxicología "
    },{
      "name": "Patología Clínica "
    },
    ]

}
